import React, { useState } from "react";
import "./PhotoGallery2025Styles.css";
import Footer from "../../../Components/FooterItems/Footer";
import ShikhaaLogo from "../../../Assets/Cover/Shikhaa_Logo.png";
import image1 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_001.png";
import image2 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_002.png";
import image3 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_003.png";
import image4 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_004.png";
import image5 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_005.png";
import image6 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_006.png";
import image7 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_007.png";
import image8 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_008.png";
import image9 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_009.png";
import image10 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_010.png";
import image11 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_011.png";
import image12 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_012.png";
import image13 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_013.png";
import image14 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_014.png";
import image15 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_015.png";
import image16 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_016.png";
import image17 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_017.png";
import image18 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_018.png";
import image19 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_019.png";
import image20 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_020.png";
import image21 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_021.png";
import image22 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_022.png";
import image23 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_023.png";
import image24 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_024.png";
import image25 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_025.png";
import image26 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_026.png";
import image27 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_027.png";
import image28 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_028.png";
import image29 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_029.png";
import image30 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_030.png";
import image31 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_031.png";
import image32 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_032.png";
import image33 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_033.png";
import image34 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_034.png";
import image35 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_035.png";
import image36 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_036.png";
import image37 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_037.png";
import image38 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_038.png";
import image39 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_039.png";
import image40 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_040.png";
import image41 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_041.png";
import image42 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_042.png";
import image43 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_043.png";
import image44 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_044.png";
import image45 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_045.png";
import image46 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_046.png";
import image47 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_047.png";
import image48 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_048.png";
import image49 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_049.png";
import image50 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_050.png";
import image51 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_051.png";
import image52 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_052.png";
import image53 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_053.png";
import image54 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_054.png";
import image55 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_055.png";
import image56 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_056.png";
import image57 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_057.png";
import image58 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_058.png";
import image59 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_059.png";
import image60 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_060.png";
import image61 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_061.png";
import image62 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_062.png";
import image63 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_063.png";
import image64 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_064.png";
import image65 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_065.png";
import image66 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_066.png";
import image67 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_067.png";
import image68 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_068.png";
import image69 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_069.png";
import image70 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_070.png";
import image71 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_071.png";
import image72 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_072.png";
import image73 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_073.png";
import image74 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_074.png";
import image75 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_075.png";
import image76 from "../../../Assets/Multimedia/Photogallery_2025/Poush_25_076.png";

const PhotoGallery2025 = () => {
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34,
    image35,
    image36,
    image37,
    image38,
    image39,
    image40,
    image41,
    image42,
    image43,
    image44,
    image45,
    image46,
    image47,
    image48,
    image49,
    image50,
    image51,
    image52,
    image53,
    image54,
    image55,
    image56,
    image57,
    image58,
    image59,
    image60,
    image61,
    image62,
    image63,
    image64,
    image65,
    image66,
    image67,
    image68,
    image69,
    image70,
    image71,
    image72,
    image73,
    image74,
    image75,
    image76,
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (index) => {
    setIsModalOpen(true);
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length,
    );
  };

  return (
    <div className="photo-gallery-container">
      <div className="photo-gallery-logo">
        <img src={ShikhaaLogo} alt="Shikhaa The Light Logo" />
      </div>

      <h1>SHIKHAA – THE LIGHT PHOTO GALLERY</h1>

      <p className="photo-gallery-intro">
        A collection of memorable moments from Shikhaa – The Light cultural
        events, community gatherings, and celebrations of Bangladeshi heritage
        in South Florida.
      </p>

      <div className="photo-gallery-grid">
        {images.map((image, index) => (
          <div
            className="thumbnail"
            key={index}
            onClick={() => openModal(index)}
          >
            <img src={image} alt={`Shikhaa gallery ${index + 1}`} />
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="gallery-modal">
          <button className="gallery-close" onClick={closeModal}>
            ×
          </button>

          <button className="gallery-arrow gallery-prev" onClick={prevImage}>
            ❮
          </button>

          <img
            src={images[currentImageIndex]}
            alt={`Shikhaa full view ${currentImageIndex + 1}`}
            className="gallery-modal-image"
          />

          <button className="gallery-arrow gallery-next" onClick={nextImage}>
            ❯
          </button>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default PhotoGallery2025;
